import { render, staticRenderFns } from "./RiskNumberAmount.vue?vue&type=template&id=27ea5ffb&scoped=true"
import script from "./RiskNumberAmount.vue?vue&type=script&lang=js"
export * from "./RiskNumberAmount.vue?vue&type=script&lang=js"
import style0 from "./RiskNumberAmount.vue?vue&type=style&index=0&id=27ea5ffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ea5ffb",
  null
  
)

export default component.exports